import { FaInstagram } from 'react-icons/fa';
import logo from '../img/logo.png';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img src={logo} alt="Liiviiart logo" />
        </div>
        <div className="footer-contact">
          <a href="mailto:liiviiart@gmail.com" className="footer-link">
            liiviiart@gmail.com
          </a>
          <a
            href="https://instagram.com/liiviiart"
            target="_blank"
            rel="noreferrer"
            className="footer-link icon-link"
            aria-label="Liiviiart on Instagram"
          >
            <FaInstagram size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
